import $ from "jquery";

import "@/sass/frontend.scss";

function setChoiceLimit() {
  $(".giveaway-choice__modal").each(function () {
    const $this = $(this);
    const maxChoiceNumber = $this.data("max");

    $this.find(".giveaway-choice-checkbox").on("change", function () {
      const $checked = $this.find(".giveaway-choice-checkbox:checked");
      const $notChecked = $this.find(".giveaway-choice-checkbox:not(:checked)");
      if ($checked.length >= maxChoiceNumber) {
        $notChecked.prop("disabled", true);
        return;
      }

      $notChecked.prop("disabled", false);
    });
  });
}

setChoiceLimit();
$(document.body).on("updated_wc_div", setChoiceLimit);

$(document).on("click", ".giveaway-choice__modal--close", function () {
  $(".giveaway-choice__modal").css("display", "none");
});

$(document).on("click", ".giveaway-choice__modal", function (e) {
  if ($(e.target).is(".giveaway-choice__modal")) {
    $(".giveaway-choice__modal").css("display", "none");
  }
});

$(document).on("click", "a[data-modal-target]", function () {
  const target = $(this).data("modal-target");
  $("." + target).css("display", "flex");
});
